// Sistema de permisos basado en roles
// Define qué puede ver y hacer cada rol en el sistema

export const ROLES = {
  ADMIN: 'admin',
  TRAINER: 'capacitador',
  EXECUTIVE: 'ejecutivo',
  STANDARD: 'standard',
  TASKS: 'tareas'
};

// Definición de permisos por rol
export const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: {
    // Administrador puede ver todo y hacer todo
    canViewClients: true,
    canCreateClients: true,
    canEditClients: true,
    canDeleteClients: true,
    
    canViewMeetings: true,
    canCreateMeetings: true,
    canEditMeetings: true,
    canDeleteMeetings: true,
    
    canViewTasks: true,
    canCreateTasks: true,
    canEditTasks: true,
    canDeleteTasks: true,
    canApproveTasks: true,
    
    canViewBudgetOperations: true,
    canCreateBudgetOperations: true,
    canEditBudgetOperations: true,
    canDeleteBudgetOperations: true,
    
    canViewCampaignTracking: true,
    canCreateCampaignTracking: true,
    canEditCampaignTracking: true,
    canDeleteCampaignTracking: true,
    
    canViewBalanceReduction: true,
    canCreateBalanceReduction: true,
    canEditBalanceReduction: true,
    canDeleteBalanceReduction: true,
    
    canViewNoTrafficClients: true,
    canCreateNoTrafficClients: true,
    canEditNoTrafficClients: true,
    canDeleteNoTrafficClients: true,
    
    canViewExcessJunkClients: true,
    canCreateExcessJunkClients: true,
    canEditExcessJunkClients: true,
    canDeleteExcessJunkClients: true,
    
    canViewCpcTrafficClients: true,
    canCreateCpcTrafficClients: true,
    canEditCpcTrafficClients: true,
    canDeleteCpcTrafficClients: true,
    
    canViewConversionDrops: true,
    canCreateConversionDrops: true,
    canEditConversionDrops: true,
    canDeleteConversionDrops: true,
    
    canViewVerifications: true,
    canCreateVerifications: true,
    canEditVerifications: true,
    canDeleteVerifications: true,
    
    canViewNoAnswerClients: true,
    canCreateNoAnswerClients: true,
    canEditNoAnswerClients: true,
    canDeleteNoAnswerClients: true,
    
    canViewNoContactClients: true,
    canCreateNoContactClients: true,
    canEditNoContactClients: true,
    canDeleteNoContactClients: true,
    
    // Permisos Meta
    canViewMeta: true,
    canViewMetaBudgetIncrease: true,
    canCreateMetaBudgetIncrease: true,
    canEditMetaBudgetIncrease: true,
    canDeleteMetaBudgetIncrease: true,
    
    canViewMetaCampaignTracking: true,
    canCreateMetaCampaignTracking: true,
    canEditMetaCampaignTracking: true,
    canDeleteMetaCampaignTracking: true,
    
    canViewMetaBalanceReduction: true,
    canCreateMetaBalanceReduction: true,
    canEditMetaBalanceReduction: true,
    canDeleteMetaBalanceReduction: true,
    
    canViewMetaNoContact: true,
    canCreateMetaNoContact: true,
    canEditMetaNoContact: true,
    canDeleteMetaNoContact: true,
    
    canViewMetaCostIncrease: true,
    canCreateMetaCostIncrease: true,
    canEditMetaCostIncrease: true,
    canDeleteMetaCostIncrease: true,
    
    canViewMetaVerifications: true,
    canCreateMetaVerifications: true,
    canEditMetaVerifications: true,
    canDeleteMetaVerifications: true,
    
    canViewMetaNoAnswer: true,
    canCreateMetaNoAnswer: true,
    canEditMetaNoAnswer: true,
    canDeleteMetaNoAnswer: true,
    
    canViewMetaBudgetReview: true,
    canCreateMetaBudgetReview: true,
    canEditMetaBudgetReview: true,
    canDeleteMetaBudgetReview: true,
    
    // Permisos Google Ads
    canViewGoogleAds: true,
    canCreateGoogleAds: true,
    canEditGoogleAds: true,
    canDeleteGoogleAds: true,
    canManageGoogleAdsAccounts: true,
    canConfigureGoogleAdsAlerts: true,
    canExportGoogleAdsReports: true,
    
    canViewUsers: true,
    canCreateUsers: true,
    canEditUsers: true,
    canDeleteUsers: true,
    
    canViewReports: true,
    canExportData: true,
    canViewHistory: true,
    canManageSystem: true
  },
  
  [ROLES.TRAINER]: {
    // Capacitador puede ver SOLO los expedientes y agregar expedientes (juntas) - FILTRADO POR CÉLULAS
    canViewClients: true,
    canCreateClients: false,
    canEditClients: false,
    canDeleteClients: false,
    
    canViewMeetings: true,
    canCreateMeetings: true, // Puede agregar juntas/expedientes
    canEditMeetings: true,
    canDeleteMeetings: false,
    
    canViewTasks: false, // NO puede ver tareas
    canCreateTasks: false, // NO puede crear tareas
    canEditTasks: false,
    canDeleteTasks: false,
    canApproveTasks: false,
    
    canViewBudgetOperations: false, // NO puede ver operaciones
    canCreateBudgetOperations: false, // NO puede crear operaciones
    canEditBudgetOperations: false,
    canDeleteBudgetOperations: false,
    
    canViewCampaignTracking: false, // NO puede ver seguimiento de campañas
    canCreateCampaignTracking: false,
    canEditCampaignTracking: false,
    canDeleteCampaignTracking: false,
    
    canViewBalanceReduction: false, // NO puede ver clientes que bajan saldo
    canCreateBalanceReduction: false,
    canEditBalanceReduction: false,
    canDeleteBalanceReduction: false,
    
    canViewNoTrafficClients: false, // NO puede ver sin tráfico
    canCreateNoTrafficClients: false,
    canEditNoTrafficClients: false,
    canDeleteNoTrafficClients: false,
    
    canViewExcessJunkClients: false, // NO puede ver exceso de basura
    canCreateExcessJunkClients: false,
    canEditExcessJunkClients: false,
    canDeleteExcessJunkClients: false,
    
    canViewCpcTrafficClients: false, // NO puede ver aumento CPC y ↓ tráfico
    canCreateCpcTrafficClients: false,
    canEditCpcTrafficClients: false,
    canDeleteCpcTrafficClients: false,
    
    canViewConversionDrops: false, // NO puede ver conversiones caídas
    canCreateConversionDrops: false,
    canEditConversionDrops: false,
    canDeleteConversionDrops: false,
    
    canViewVerifications: false, // NO puede ver verificaciones
    canCreateVerifications: false,
    canEditVerifications: false,
    canDeleteVerifications: false,
    
    canViewNoAnswerClients: false, // NO puede ver clientes que no contestan
    canCreateNoAnswerClients: false,
    canEditNoAnswerClients: false,
    canDeleteNoAnswerClients: false,
    
    canViewNoContactClients: false, // NO puede ver bajaron o sin contactos
    canCreateNoContactClients: false,
    canEditNoContactClients: false,
    canDeleteNoContactClients: false,
    
    // Permisos Meta - TRAINER NO puede ver Meta
    canViewMeta: false,
    canViewMetaBudgetIncrease: false,
    canCreateMetaBudgetIncrease: false,
    canEditMetaBudgetIncrease: false,
    canDeleteMetaBudgetIncrease: false,
    
    canViewMetaCampaignTracking: false,
    canCreateMetaCampaignTracking: false,
    canEditMetaCampaignTracking: false,
    canDeleteMetaCampaignTracking: false,
    
    canViewMetaBalanceReduction: false,
    canCreateMetaBalanceReduction: false,
    canEditMetaBalanceReduction: false,
    canDeleteMetaBalanceReduction: false,
    
    canViewMetaNoContact: false,
    canCreateMetaNoContact: false,
    canEditMetaNoContact: false,
    canDeleteMetaNoContact: false,
    
    canViewMetaCostIncrease: false,
    canCreateMetaCostIncrease: false,
    canEditMetaCostIncrease: false,
    canDeleteMetaCostIncrease: false,
    
    canViewMetaVerifications: false,
    canCreateMetaVerifications: false,
    canEditMetaVerifications: false,
    canDeleteMetaVerifications: false,
    
    canViewMetaNoAnswer: false,
    canCreateMetaNoAnswer: false,
    canEditMetaNoAnswer: false,
    canDeleteMetaNoAnswer: false,
    
    canViewMetaBudgetReview: false,
    canCreateMetaBudgetReview: false,
    canEditMetaBudgetReview: false,
    canDeleteMetaBudgetReview: false,
    
    // Permisos Google Ads - TRAINER NO puede ver Google Ads
    canViewGoogleAds: false,
    canCreateGoogleAds: false,
    canEditGoogleAds: false,
    canDeleteGoogleAds: false,
    canManageGoogleAdsAccounts: false,
    canConfigureGoogleAdsAlerts: false,
    canExportGoogleAdsReports: false,
    
    canViewUsers: false,
    canCreateUsers: false,
    canEditUsers: false,
    canDeleteUsers: false,
    
    canViewReports: false,
    canExportData: false,
    canViewHistory: true, // Solo historial de sus propias juntas
    canManageSystem: false,
    
    // FILTRADO POR CÉLULAS - Solo ve datos de sus células asignadas
    requiresCellFiltering: true
  },
  
  [ROLES.EXECUTIVE]: {
    // Ejecutivo puede ver expedientes, hacer expedientes, ver y hacer tareas, ver operaciones y agregar registros - FILTRADO POR CÉLULAS
    canViewClients: true,
    canCreateClients: true,
    canEditClients: true,
    canDeleteClients: false,
    
    canViewMeetings: true,
    canCreateMeetings: true, // Puede hacer expedientes
    canEditMeetings: true,
    canDeleteMeetings: false,
    
    canViewTasks: true, // Puede ver tareas (filtradas por células)
    canCreateTasks: true, // Puede hacer tareas (filtradas por células)
    canEditTasks: true,
    canDeleteTasks: false,
    canApproveTasks: false,
    
    canViewBudgetOperations: true, // Puede ver operaciones (filtradas por células)
    canCreateBudgetOperations: true, // Puede agregar registros (filtradas por células)
    canEditBudgetOperations: true,
    canDeleteBudgetOperations: false,
    
    canViewCampaignTracking: true, // Filtradas por células
    canCreateCampaignTracking: true,
    canEditCampaignTracking: true,
    canDeleteCampaignTracking: false,
    
    canViewBalanceReduction: true, // Filtradas por células
    canCreateBalanceReduction: true,
    canEditBalanceReduction: true,
    canDeleteBalanceReduction: false,
    
    canViewNoTrafficClients: true, // Filtradas por células
    canCreateNoTrafficClients: true,
    canEditNoTrafficClients: true,
    canDeleteNoTrafficClients: false,
    
    canViewExcessJunkClients: true, // Filtradas por células
    canCreateExcessJunkClients: true,
    canEditExcessJunkClients: true,
    canDeleteExcessJunkClients: false,
    
    canViewCpcTrafficClients: true, // Filtradas por células
    canCreateCpcTrafficClients: true,
    canEditCpcTrafficClients: true,
    canDeleteCpcTrafficClients: false,
    
    canViewConversionDrops: true, // Filtradas por células
    canCreateConversionDrops: true,
    canEditConversionDrops: true,
    canDeleteConversionDrops: false,
    
    canViewVerifications: true, // Filtradas por células
    canCreateVerifications: true,
    canEditVerifications: true,
    canDeleteVerifications: false,
    
    canViewNoAnswerClients: true, // Filtradas por células
    canCreateNoAnswerClients: true,
    canEditNoAnswerClients: true,
    canDeleteNoAnswerClients: false,
    
    canViewNoContactClients: true, // Filtradas por células
    canCreateNoContactClients: true,
    canEditNoContactClients: true,
    canDeleteNoContactClients: false,
    
    // Permisos Meta - EXECUTIVE puede ver y crear Meta (filtradas por células)
    canViewMeta: true,
    canViewMetaBudgetIncrease: true,
    canCreateMetaBudgetIncrease: true,
    canEditMetaBudgetIncrease: true,
    canDeleteMetaBudgetIncrease: false,
    
    canViewMetaCampaignTracking: true,
    canCreateMetaCampaignTracking: true,
    canEditMetaCampaignTracking: true,
    canDeleteMetaCampaignTracking: false,
    
    canViewMetaBalanceReduction: true,
    canCreateMetaBalanceReduction: true,
    canEditMetaBalanceReduction: true,
    canDeleteMetaBalanceReduction: false,
    
    canViewMetaNoContact: true,
    canCreateMetaNoContact: true,
    canEditMetaNoContact: true,
    canDeleteMetaNoContact: false,
    
    canViewMetaCostIncrease: true,
    canCreateMetaCostIncrease: true,
    canEditMetaCostIncrease: true,
    canDeleteMetaCostIncrease: false,
    
    canViewMetaVerifications: true,
    canCreateMetaVerifications: true,
    canEditMetaVerifications: true,
    canDeleteMetaVerifications: false,
    
    canViewMetaNoAnswer: true,
    canCreateMetaNoAnswer: true,
    canEditMetaNoAnswer: true,
    canDeleteMetaNoAnswer: false,
    
    canViewMetaBudgetReview: true,
    canCreateMetaBudgetReview: true,
    canEditMetaBudgetReview: true,
    canDeleteMetaBudgetReview: false,
    
    // Permisos Google Ads - EXECUTIVE puede ver y crear Google Ads (filtradas por células)
    canViewGoogleAds: true,
    canCreateGoogleAds: true,
    canEditGoogleAds: true,
    canDeleteGoogleAds: false,
    canManageGoogleAdsAccounts: true,
    canConfigureGoogleAdsAlerts: true,
    canExportGoogleAdsReports: true,
    
    canViewUsers: false,
    canCreateUsers: false,
    canEditUsers: false,
    canDeleteUsers: false,
    
    canViewReports: true,
    canExportData: false,
    canViewHistory: true,
    canManageSystem: false,
    
    // FILTRADO POR CÉLULAS - Solo ve datos de sus células asignadas
    requiresCellFiltering: true
  },
  
  [ROLES.STANDARD]: {
    // Usuario estándar (permisos limitados) - FILTRADO POR CÉLULAS
    canViewClients: true,
    canCreateClients: false,
    canEditClients: false,
    canDeleteClients: false,
    
    canViewMeetings: true,
    canCreateMeetings: false,
    canEditMeetings: false,
    canDeleteMeetings: false,
    
    canViewTasks: true, // Filtradas por células
    canCreateTasks: false,
    canEditTasks: false,
    canDeleteTasks: false,
    canApproveTasks: false,
    
    canViewBudgetOperations: true, // Filtradas por células
    canCreateBudgetOperations: false,
    canEditBudgetOperations: false,
    canDeleteBudgetOperations: false,
    
    canViewCampaignTracking: true, // Filtradas por células
    canCreateCampaignTracking: false,
    canEditCampaignTracking: false,
    canDeleteCampaignTracking: false,
    
    canViewBalanceReduction: true, // Filtradas por células
    canCreateBalanceReduction: false,
    canEditBalanceReduction: false,
    canDeleteBalanceReduction: false,
    
    canViewNoTrafficClients: true, // Filtradas por células
    canCreateNoTrafficClients: false,
    canEditNoTrafficClients: false,
    canDeleteNoTrafficClients: false,
    
    canViewExcessJunkClients: true, // Filtradas por células
    canCreateExcessJunkClients: false,
    canEditExcessJunkClients: false,
    canDeleteExcessJunkClients: false,
    
    canViewCpcTrafficClients: true, // Filtradas por células
    canCreateCpcTrafficClients: false,
    canEditCpcTrafficClients: false,
    canDeleteCpcTrafficClients: false,
    
    canViewConversionDrops: true, // Filtradas por células
    canCreateConversionDrops: false,
    canEditConversionDrops: false,
    canDeleteConversionDrops: false,
    
    canViewVerifications: true, // Filtradas por células
    canCreateVerifications: false,
    canEditVerifications: false,
    canDeleteVerifications: false,
    
    canViewNoAnswerClients: true, // Filtradas por células
    canCreateNoAnswerClients: false,
    canEditNoAnswerClients: false,
    canDeleteNoAnswerClients: false,
    
    canViewNoContactClients: true, // Filtradas por células
    canCreateNoContactClients: false,
    canEditNoContactClients: false,
    canDeleteNoContactClients: false,
    
    // Permisos Meta - STANDARD solo puede ver Meta (filtradas por células)
    canViewMeta: true,
    canViewMetaBudgetIncrease: true,
    canCreateMetaBudgetIncrease: false,
    canEditMetaBudgetIncrease: false,
    canDeleteMetaBudgetIncrease: false,
    
    canViewMetaCampaignTracking: true,
    canCreateMetaCampaignTracking: false,
    canEditMetaCampaignTracking: false,
    canDeleteMetaCampaignTracking: false,
    
    canViewMetaBalanceReduction: true,
    canCreateMetaBalanceReduction: false,
    canEditMetaBalanceReduction: false,
    canDeleteMetaBalanceReduction: false,
    
    canViewMetaNoContact: true,
    canCreateMetaNoContact: false,
    canEditMetaNoContact: false,
    canDeleteMetaNoContact: false,
    
    canViewMetaCostIncrease: true,
    canCreateMetaCostIncrease: false,
    canEditMetaCostIncrease: false,
    canDeleteMetaCostIncrease: false,
    
    canViewMetaVerifications: true,
    canCreateMetaVerifications: false,
    canEditMetaVerifications: false,
    canDeleteMetaVerifications: false,
    
    canViewMetaNoAnswer: true,
    canCreateMetaNoAnswer: false,
    canEditMetaNoAnswer: false,
    canDeleteMetaNoAnswer: false,
    
    canViewMetaBudgetReview: true,
    canCreateMetaBudgetReview: false,
    canEditMetaBudgetReview: false,
    canDeleteMetaBudgetReview: false,
    
    // Permisos Google Ads - STANDARD solo puede ver Google Ads (filtradas por células)
    canViewGoogleAds: true,
    canCreateGoogleAds: false,
    canEditGoogleAds: false,
    canDeleteGoogleAds: false,
    canManageGoogleAdsAccounts: false,
    canConfigureGoogleAdsAlerts: false,
    canExportGoogleAdsReports: false,
    
    canViewUsers: false,
    canCreateUsers: false,
    canEditUsers: false,
    canDeleteUsers: false,
    
    canViewReports: false,
    canExportData: false,
    canViewHistory: false,
    canManageSystem: false,
    
    // FILTRADO POR CÉLULAS - Solo ve datos de sus células asignadas
    requiresCellFiltering: true
  },
  
  [ROLES.TASKS]: {
    // Usuario de Tareas: solo puede ver y gestionar tareas, sin acceso a clientes.
    canViewClients: false,
    canCreateClients: false,
    canEditClients: false,
    canDeleteClients: false,
    
    canViewMeetings: true, // Puede ver juntas para contexto de tareas
    canCreateMeetings: false,
    canEditMeetings: false,
    canDeleteMeetings: false,
    
    canViewTasks: true,
    canCreateTasks: true,
    canEditTasks: true,
    canDeleteTasks: false,
    canApproveTasks: false,
    
    canViewBudgetOperations: true, // TAREAS SÍ puede ver operaciones de presupuesto
    canCreateBudgetOperations: false,
    canEditBudgetOperations: false,
    canDeleteBudgetOperations: false,
    
    canViewCampaignTracking: true, // TAREAS SÍ puede ver seguimiento de campañas
    canCreateCampaignTracking: false,
    canEditCampaignTracking: false,
    canDeleteCampaignTracking: false,
    
    canViewBalanceReduction: true, // TAREAS SÍ puede ver clientes que bajan saldo
    canCreateBalanceReduction: false,
    canEditBalanceReduction: false,
    canDeleteBalanceReduction: false,
    
    canViewNoTrafficClients: true, // TAREAS SÍ puede ver sin tráfico
    canCreateNoTrafficClients: false,
    canEditNoTrafficClients: false,
    canDeleteNoTrafficClients: false,
    
    canViewExcessJunkClients: true, // TAREAS SÍ puede ver exceso de basura
    canCreateExcessJunkClients: false,
    canEditExcessJunkClients: false,
    canDeleteExcessJunkClients: false,
    
    canViewCpcTrafficClients: true, // TAREAS SÍ puede ver aumento CPC y ↓ tráfico
    canCreateCpcTrafficClients: false,
    canEditCpcTrafficClients: false,
    canDeleteCpcTrafficClients: false,
    
    canViewConversionDrops: true, // TAREAS SÍ puede ver conversiones caídas
    canCreateConversionDrops: false,
    canEditConversionDrops: false,
    canDeleteConversionDrops: false,
    
    canViewVerifications: true, // TAREAS SÍ puede ver verificaciones
    canCreateVerifications: false,
    canEditVerifications: false,
    canDeleteVerifications: false,
    
    canViewNoAnswerClients: true, // TAREAS SÍ puede ver clientes que no contestan
    canCreateNoAnswerClients: false,
    canEditNoAnswerClients: false,
    canDeleteNoAnswerClients: false,
    
    canViewNoContactClients: true, // TAREAS SÍ puede ver bajaron o sin contactos
    canCreateNoContactClients: false,
    canEditNoContactClients: false,
    canDeleteNoContactClients: false,
    
    // Permisos Meta - TAREAS SÍ puede ver Meta
    canViewMeta: true,
    canViewMetaBudgetIncrease: true,
    canCreateMetaBudgetIncrease: false,
    canEditMetaBudgetIncrease: false,
    canDeleteMetaBudgetIncrease: false,
    
    canViewMetaCampaignTracking: true,
    canCreateMetaCampaignTracking: false,
    canEditMetaCampaignTracking: false,
    canDeleteMetaCampaignTracking: false,
    
    canViewMetaBalanceReduction: true,
    canCreateMetaBalanceReduction: false,
    canEditMetaBalanceReduction: false,
    canDeleteMetaBalanceReduction: false,
    
    canViewMetaNoContact: true,
    canCreateMetaNoContact: false,
    canEditMetaNoContact: false,
    canDeleteMetaNoContact: false,
    
    canViewMetaCostIncrease: true,
    canCreateMetaCostIncrease: false,
    canEditMetaCostIncrease: false,
    canDeleteMetaCostIncrease: false,
    
    canViewMetaVerifications: true,
    canCreateMetaVerifications: false,
    canEditMetaVerifications: false,
    canDeleteMetaVerifications: false,
    
    canViewMetaNoAnswer: true,
    canCreateMetaNoAnswer: false,
    canEditMetaNoAnswer: false,
    canDeleteMetaNoAnswer: false,
    
    canViewMetaBudgetReview: true,
    canCreateMetaBudgetReview: false,
    canEditMetaBudgetReview: false,
    canDeleteMetaBudgetReview: false,
    
    // Permisos Google Ads - TAREAS SÍ puede ver Google Ads
    canViewGoogleAds: true,
    canCreateGoogleAds: false,
    canEditGoogleAds: false,
    canDeleteGoogleAds: false,
    canManageGoogleAdsAccounts: false,
    canConfigureGoogleAdsAlerts: false,
    canExportGoogleAdsReports: false,
    
    canViewUsers: false,
    canCreateUsers: false,
    canEditUsers: false,
    canDeleteUsers: false,
    
    canViewReports: false,
    canExportData: false,
    canViewHistory: true,
    canManageSystem: false,
    
    requiresCellFiltering: true
  }
};

// Función para verificar si un usuario tiene un permiso específico
export const hasPermission = (userRole, permission) => {
  if (!userRole || !permission) return false;
  
  const rolePermissions = ROLE_PERMISSIONS[userRole];
  if (!rolePermissions) return false;
  
  return rolePermissions[permission] === true;
};

// Función para obtener todos los permisos de un rol
export const getRolePermissions = (userRole) => {
  if (!userRole) return {};
  return ROLE_PERMISSIONS[userRole] || {};
};

// Función para verificar si un usuario puede acceder a una sección
export const canAccessSection = (userRole, section) => {
  const permissions = getRolePermissions(userRole);
  
  switch (section) {
    case 'clients':
      return permissions.canViewClients;
    case 'meetings':
      return permissions.canViewMeetings;
    case 'tasks':
      return permissions.canViewTasks;
    case 'budget-operations':
      return permissions.canViewBudgetOperations;
    case 'campaign-tracking':
      return permissions.canViewCampaignTracking;
    case 'balance-reduction':
      return permissions.canViewBalanceReduction;
    case 'no-traffic-clients':
      return permissions.canViewNoTrafficClients;
    case 'excess-junk-clients':
      return permissions.canViewExcessJunkClients;
    case 'cpc-traffic-clients':
      return permissions.canViewCpcTrafficClients;
    case 'conversion-drops':
      return permissions.canViewConversionDrops;
    case 'verifications':
      return permissions.canViewVerifications;
    case 'no-answer-clients':
      return permissions.canViewNoAnswerClients;
    case 'no-contact-clients':
      return permissions.canViewNoContactClients;
    case 'meta':
      return permissions.canViewMeta;
    case 'meta-budget-increase':
      return permissions.canViewMetaBudgetIncrease;
    case 'meta-campaign-tracking':
      return permissions.canViewMetaCampaignTracking;
    case 'meta-balance-reduction':
      return permissions.canViewMetaBalanceReduction;
    case 'meta-no-contact':
      return permissions.canViewMetaNoContact;
    case 'meta-cost-increase':
      return permissions.canViewMetaCostIncrease;
    case 'meta-verifications':
      return permissions.canViewMetaVerifications;
    case 'meta-no-answer':
      return permissions.canViewMetaNoAnswer;
    case 'meta-budget-review':
      return permissions.canViewMetaBudgetReview;
    case 'users':
      return permissions.canViewUsers;
    case 'reports':
      return permissions.canViewReports;
    default:
      return false;
  }
};

// Función para obtener las secciones visibles para un rol
export const getVisibleSections = (userRole) => {
  const permissions = getRolePermissions(userRole);
  const sections = [];
  
  if (permissions.canViewClients) sections.push('clients');
  if (permissions.canViewMeetings) sections.push('meetings');
  if (permissions.canViewTasks) sections.push('tasks');
  if (permissions.canViewBudgetOperations) sections.push('budget-operations');
  if (permissions.canViewCampaignTracking) sections.push('campaign-tracking');
  if (permissions.canViewBalanceReduction) sections.push('balance-reduction');
  if (permissions.canViewNoTrafficClients) sections.push('no-traffic-clients');
  if (permissions.canViewExcessJunkClients) sections.push('excess-junk-clients');
  if (permissions.canViewCpcTrafficClients) sections.push('cpc-traffic-clients');
  if (permissions.canViewConversionDrops) sections.push('conversion-drops');
  if (permissions.canViewVerifications) sections.push('verifications');
  if (permissions.canViewNoAnswerClients) sections.push('no-answer-clients');
  if (permissions.canViewNoContactClients) sections.push('no-contact-clients');
  if (permissions.canViewUsers) sections.push('users');
  if (permissions.canViewReports) sections.push('reports');
  
  return sections;
};

// Función para verificar si un usuario puede ver una sección basada en su especialidad de plataforma
export const canViewSectionByPlatform = (userPlatformSpecialty, sectionId) => {
  // Si el usuario puede ver ambas plataformas, puede ver todo
  if (userPlatformSpecialty === 'both') return true;
  
  // Secciones de Google Ads
  const googleAdsSections = [
    'googleAds',
    'budgetOperations',
    'campaignTracking', 
    'balanceReduction',
    'noContactClients',
    'noTrafficClients',
    'excessJunkClients',
    'cpcTrafficClients',
    'conversionDrops',
    'verifications',
    'noAnswerClients'
  ];
  
  // Secciones de Meta
  const metaSections = [
    'metaBudgetIncrease',
    'metaCampaignTracking',
    'metaBalanceReduction',
    'metaNoContact',
    'metaCostIncrease',
    'metaVerifications',
    'metaNoAnswer',
    'metaBudgetReview'
  ];
  
  // Secciones generales (disponibles para todos)
  const generalSections = [
    'dashboard',
    'clients',
    'allTasks',
    'admin'
  ];
  
  // Verificar acceso según especialidad
  if (generalSections.includes(sectionId)) return true;
  
  if (userPlatformSpecialty === 'google_ads') {
    return googleAdsSections.includes(sectionId);
  }
  
  if (userPlatformSpecialty === 'meta') {
    return metaSections.includes(sectionId);
  }
  
  return false;
};

// Función para obtener las secciones visibles filtradas por plataforma
export const getVisibleSectionsByPlatform = (userRole, userPlatformSpecialty) => {
  const allSections = getVisibleSections(userRole);
  
  // Si no tiene especialidad definida o es 'both', mostrar todo
  if (!userPlatformSpecialty || userPlatformSpecialty === 'both') {
    return allSections;
  }
  
  // Filtrar secciones según la especialidad de plataforma
  return allSections.filter(section => canViewSectionByPlatform(userPlatformSpecialty, section));
};

// Función para obtener el nombre legible de un rol
export const getRoleName = (role) => {
  switch (role) {
    case ROLES.ADMIN:
      return 'Administrador';
    case ROLES.TRAINER:
      return 'Capacitador';
    case ROLES.EXECUTIVE:
      return 'Ejecutivo';
    case ROLES.STANDARD:
      return 'Usuario Estándar';
    case ROLES.TASKS:
      return 'Tareas';
    default:
      return 'Usuario';
  }
};

// Función para obtener la descripción de un rol
export const getRoleDescription = (role) => {
  switch (role) {
    case ROLES.ADMIN:
      return 'Puede ver todo y hacer todo en el sistema';
    case ROLES.TRAINER:
      return 'Puede ver solo los expedientes y agregar expedientes (juntas)';
    case ROLES.EXECUTIVE:
      return 'Puede ver expedientes, hacer expedientes, ver y hacer tareas, ver operaciones y agregar registros';
    case ROLES.STANDARD:
      return 'Acceso de solo lectura a la mayoría de secciones';
    case ROLES.TASKS:
      return 'Puede ver y gestionar tareas, sin acceso a la gestión de clientes';
    default:
      return 'Usuario del sistema';
  }
};

// Función para verificar si un rol requiere filtrado por células
export const requiresCellFiltering = (userRole) => {
  const permissions = getRolePermissions(userRole);
  return permissions.requiresCellFiltering === true;
};

// Función para verificar si un usuario puede ver un cliente específico
export const canViewClient = (userRole, userCells, clientCell) => {
  // Admin puede ver todo
  if (userRole === ROLES.ADMIN) return true;
  
  // Si no requiere filtrado por células, puede ver todo
  if (!requiresCellFiltering(userRole)) return true;
  
  // Si no tiene células asignadas, no puede ver nada
  if (!userCells || userCells.length === 0) return false;
  
  // Verificar si el cliente pertenece a alguna de las células del usuario
  return userCells.includes(clientCell);
};

// Función para obtener el filtro SQL para células
export const getCellFilter = (userRole, userCells, tableAlias = '') => {
  // Admin puede ver todo
  if (userRole === ROLES.ADMIN) return '';
  
  // Si no requiere filtrado por células, puede ver todo
  if (!requiresCellFiltering(userRole)) return '';
  
  // Si no tiene células asignadas, no puede ver nada
  if (!userCells || userCells.length === 0) return ' AND 1=0';
  
  const prefix = tableAlias ? `${tableAlias}.` : '';
  const cellsArray = Array.isArray(userCells) ? userCells : JSON.parse(userCells || '[]');
  
  if (cellsArray.length === 0) return ' AND 1=0';
  
  const cellsString = cellsArray.map(cell => `'${cell}'`).join(',');
  return ` AND ${prefix}cell IN (${cellsString})`;
};

// Función para filtrar datos por células en el frontend
export const filterDataByCells = (data, userRole, userCells, cellField = 'cell') => {
  // Admin puede ver todo
  if (userRole === ROLES.ADMIN) return data;
  
  // Si no requiere filtrado por células, puede ver todo
  if (!requiresCellFiltering(userRole)) return data;
  
  // Si no tiene células asignadas, no puede ver nada
  if (!userCells || userCells.length === 0) return [];
  
  const cellsArray = Array.isArray(userCells) ? userCells : JSON.parse(userCells || '[]');
  
  if (cellsArray.length === 0) return [];
  
  return data.filter(item => cellsArray.includes(item[cellField]));
};

// Función para verificar si un usuario puede crear/editar un registro en una célula específica
export const canModifyInCell = (userRole, userCells, targetCell) => {
  // Admin puede modificar todo
  if (userRole === ROLES.ADMIN) return true;
  
  // Si no requiere filtrado por células, puede modificar todo
  if (!requiresCellFiltering(userRole)) return true;
  
  // Si no tiene células asignadas, no puede modificar nada
  if (!userCells || userCells.length === 0) return false;
  
  const cellsArray = Array.isArray(userCells) ? userCells : JSON.parse(userCells || '[]');
  
  // Verificar si puede modificar en la célula objetivo
  return cellsArray.includes(targetCell);
};

// Función para obtener las células disponibles para un usuario
export const getAvailableCells = (userRole, userCells) => {
  // Admin puede ver todas las células (esto debería venir de la base de datos)
  if (userRole === ROLES.ADMIN) {
    return ['Célula 1', 'Célula 2', 'Célula 3', 'Célula 4', 'Célula 5']; // Ejemplo
  }
  
  // Si no requiere filtrado por células, puede ver todas
  if (!requiresCellFiltering(userRole)) {
    return ['Célula 1', 'Célula 2', 'Célula 3', 'Célula 4', 'Célula 5']; // Ejemplo
  }
  
  // Retornar solo las células asignadas al usuario
  return Array.isArray(userCells) ? userCells : JSON.parse(userCells || '[]');
};

export default {
  ROLES,
  ROLE_PERMISSIONS,
  hasPermission,
  getRolePermissions,
  canAccessSection,
  getVisibleSections,
  getRoleName,
  getRoleDescription,
  requiresCellFiltering,
  canViewClient,
  getCellFilter,
  filterDataByCells,
  canModifyInCell,
  getAvailableCells
};
